module.exports = __webpack_public_path__ + "img/investors.c16fc35e.webp";